<div class="mb-8 w-full" [formGroup]="formGroup">
  <label *ngIf="label" [for]="name" class="mb-2 block font-theme-source text-base w-full font-bold"
    [class.text-white]="!black" [class.text-theme-black]="black">
    {{label}}
  </label>
  <input [formControlName]="name" type="tel" mask="00 00 00 00 00" [placeholder]="placeholder" [attr.aria-label]="label"
         (input)="onChange.emit(formGroup.controls[name].value)" [appFocusNextId]="appFocusNextId" autocomplete="tel-national"
         [tabIndex]="tabIndex" appAutofocus [autofocus]="autoFocus" id="{{name}}" class="
  bg-white rounded-md py-[10px] px-5
  border-3
  text-base w-full
  text-theme-black font-theme-source placeholder:font-theme-source
  outline-none transition  disabled:cursor-default disabled:bg-gray-2 disabled:border-gray-2"
         [class.border-theme-orange]="formGroup.controls[name].invalid && showValidationErrors"
         [class.border-theme-green]="formGroup.controls[name].valid && showValidationErrors"
         [class.active:border-theme-orange]="formGroup.controls[name].invalid && showValidationErrors"
         [class.focus:border-theme-orange]="formGroup.controls[name].invalid && showValidationErrors"
         [class.active:border-theme-green]="formGroup.controls[name].valid && showValidationErrors"
         [class.focus:border-theme-green]="formGroup.controls[name].valid && showValidationErrors"
  />
</div>
